<div class="custom-table">
    <div class="custom-row heading-row">
        <div class="custom-column status">Status</div>
        <div class="custom-column brand">Brand</div>
        <div class="custom-column type">Item</div>
        <div class="custom-column price">Price</div>
        <!-- <div class="custom-column more"></div> -->
    </div>

    <ng-container *ngIf="isScheduled|| isRecurring">
        <div class="scheduled-info" id="scheduled-state">
            <span>Once your items arrive in our Atelier, they will be individually examined by our processing experts
                and your
                itemised invoice will show here.</span>
        </div>
    </ng-container>

    <ng-container *ngIf="!isScheduled || !isRecurring">
        <div *ngFor="let item of order.items; let i = index" id="not-scheduled-state" class="custom-row">
            <div class="custom-column first-column status">
                <span class="status tag">{{item.infoitems_Status | lowercase}}</span>
            </div>
            <div id="brandNone" *ngIf="item.brand ==='';else elseif" class="custom-column brand">-</div>
            <ng-template #elseif>
                <div class="custom-column brand">{{item.brand}}</div>
            </ng-template>
            <div class="custom-column type">{{item.typeitem}}</div>
            <div class="custom-column price">£{{item.priceTotal| number:'.2-2'}}</div>
            <div *ngIf="item.infoitems_Status == 'Pending' " class="custom-column price"> - </div>
            <!-- <div *ngIf="item.statusAsString == 'Cancelled' " class="custom-column price"> 0 </div> -->
            <!-- <div class="custom-column more">
        <a *ngIf="item.instructions" (click)="this.shown[i] = !this.shown[i]" id="show-instructions-btn"
          class="icon arrow-down" [ngClass]="{'opened': this.shown[i]}"></a>
      </div> -->
            <!-- <div *ngIf="shown[i]" class="custom-row instructions" id="instructions">
        <p>Instructions</p>
        <span *ngFor="let instruction of item.instructions" class="empty tag instruction">{{instruction}}</span>
      </div> -->
        </div>

    </ng-container>
</div>